/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  OrderSummery.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Avanthi G(E860178)
*
* @Date			: Jul 29, 2019
*
* @Version      : Version 1.0

* By            : Grandhi Srinivas (E528634)
* On            : Jul 31, 2019
* Description   : Updated code as ASDS-696
*
* By            : H352615
* On            : Aug 12, 2019
* Description   : Updated code as ASDS-997
*
* By            : H352615
* On            : Aug 26, 2019
* Description   : Updated code as ASDS-1084.
*
* By            : SandeepRaja (E807238)
* On            : Sep 26, 2019
* Description   : Show price amount with two floating numbers
*
* By            : H224423
* On            : Sep 30, 2019
* Description   : Order Summary Price calculation issue fix.
*
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes
*
* By            : H224423
* On            : NOV 08, 2019
* Description   : Order summary card - made heading rendered always. removed inline loader heading
*
* By            : SandeepRaja
* On            : NOV 28, 2019
* Description   : ASDS-1809: Order Summary - Wireless Products
*
* By            	: Madhu Gali
* On            	:  Dec 18, 2019
* Description  : ASDS-584
 *
 * By            	: H224423
 * On            	: Jan 30, 2020
 * Description    : Removed unused methods and state variables.
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H422337
 * On            : Sep 05 2022
 * Description   : ASDS-8220 - Dynamically added apu model name
 *
******************************************************************************/

import * as React from "react";
import { Card, Icon, Input, Table } from "@scuf/common";
import "@scuf/common/honeywell/theme.css";
import "./OrderSummery.css";
import "@scuf/styles/variables.scss";
import { RouteComponentProps, withRouter } from "react-router";
import { connect } from "react-redux";
import OrderSummaryActions from "../redux/actions/order-summary-actions";
import { OrderSummaryStats } from "../../../../types/";
import { InLineLoader } from "../Loader/Loader";
import { CheckoutConstants } from "../constants/checkout-constants";
import { isEmptyObject } from "../../../utils/util";
import ReviewOrderActions from "../redux/actions/review-order-actions";
import DiscountIcon from "./images/iconamoon_discount-fill.svg";

interface OrderSummeryPropsI {
  getOrderSummary: Function;
  userId: string;
  children: React.ReactNode;
  insideReviewOrder: any;
}

interface OrderSummaryStatsPropsI {
  isFetching: boolean;
  isSuccess: boolean;
  // data: OrderSummaryStats | undefined,
  data: OrderSummaryStats;
}

// Subtotal
// Coupon code
const getSubTotalPrice = (props, totalDiscountAmount) => {
  let subTotalPrice = props.data.totalPrice - totalDiscountAmount;
  return subTotalPrice.toFixed(2);
};

// Display item title and price in a row
// Coupon code
const OrderItemRow = (props) => {
  let afterDiscount = props.featurePrice - props.discountAmountData;

  return (
    <Table.Row>
      <Table.Cell width={9} className="no-bottom-border">
        {props.title}
      </Table.Cell>
      {props.checkInsideReviewOrderData ? (
        <Table.Cell width={7} className="no-bottom-border">
          <span>$ {afterDiscount.toFixed(2)}</span>
        </Table.Cell>
      ) : (
        <Table.Cell width={7} className="no-bottom-border">
          {props.isCouponApply ? (
            <span style={{ textDecoration: "line-through" }}>
              $ {props.featurePrice?.toFixed(2)}
            </span>
          ) : (
            <span>$ {props.featurePrice?.toFixed(2)}</span>
          )}
        </Table.Cell>
      )}
    </Table.Row>
  );
};

const getTaxPrice = (props) => {
  let taxPrice = props.data.taxAmount;
  return taxPrice.toFixed(2);
};
// Coupon code
const getGrandTotalPrice = (props, totalDiscountAmount) => {
  let totalPrice = 0;
  totalPrice =
    parseFloat(getSubTotalPrice(props, totalDiscountAmount)) +
    parseFloat(getTaxPrice(props));
  return totalPrice?.toFixed(2);
};
// Coupon code
const getTotalDiscountAmount = (props) => {
  return props;
};

/**
 * Displays item count and price details.
 * @param props
 */

// Coupon code
function OrderSummaryDetails(props: OrderSummaryStatsPropsI) {
  const { couponData }: any = props;
  const { discountAmount }: any = props;
  const { checkCouponData }: any = props;

  let isCouponApply = couponData?.isCoupon;

  let discountAmountData: number = isCouponApply ? discountAmount?.data : 0;

  const { checkInsideReviewOrder }: any = props;
  const checkInsideReviewOrderData = checkInsideReviewOrder?.data;

  const { checkModeldata }: any = props;
  const getModelData = checkModeldata?.getModelAData?.data;
  const { checkModelBdata }: any = props;
  const getModelBName = checkModelBdata?.getModelBName?.data;

  if (!isEmptyObject(props.data)) {
    const taxPrice = getTaxPrice(props);
    return (
      <Table className="checkoutTable unstackable">
        <Table.Body>
          <Table.Row>
            <Table.Cell width={7}>Items</Table.Cell>
            <Table.Cell width={7}>
              <b>{props.data.itemCount}</b>
            </Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.Cell colSpan={2}>
              <Table className="os-category-table unstackable">
                <Table.Body>
                  {props.data.apuProductsStats.contractCount > 0 &&
                    props.data.apuProductsStats.apuModels?.map((apuModel) => {

                      return (
                        <>
                          <OrderItemRow
                            title={`${apuModel?.modelName} Keys`}
                            featurePrice={apuModel?.totalPrice}
                            isCouponApply={isCouponApply}
                            checkInsideReviewOrderData={
                              checkInsideReviewOrderData
                            }
                            discountAmountData={discountAmountData}
                            getModelData={getModelData}
                            getKey={apuModel?.modelName}
                          />
                        </>
                      );
                    })}
                  {/* // <OrderItemRow title={`${props.data.apuProductsStats?.apuModels} Keys`} featurePrice={props.data.apuProductsStats.contractPrice} />} */}

                  {props.data.aspireProductsStats.featuresCount > 0 && (
                    <OrderItemRow
                      title={"Aspire Keys"}
                      featurePrice={
                        props.data.aspireProductsStats.featuresPrice
                      }
                      isCouponApply={isCouponApply}
                      checkInsideReviewOrderData={checkInsideReviewOrderData}
                      discountAmountData={discountAmountData}
                    />
                  )}

                  {props.data.DLMUWProductsStats.count > 0 && (
                    <OrderItemRow
                      title={CheckoutConstants.DLMUW_CATEGORY_NAME.toUpperCase()}
                      featurePrice={props.data.DLMUWProductsStats.price}
                      isCouponApply={isCouponApply}
                      checkInsideReviewOrderData={checkInsideReviewOrderData}
                      discountAmountData={discountAmountData}
                    />
                  )}

                  {props.data.analyzerSCProductsStats.count > 0 && (
                    <OrderItemRow
                      title={
                        CheckoutConstants.ANALYZER_SERVICE_CENTER_PRODUCT_NAME
                      }
                      featurePrice={props.data.analyzerSCProductsStats.price}
                      isCouponApply={isCouponApply}
                      checkInsideReviewOrderData={checkInsideReviewOrderData}
                      discountAmountData={discountAmountData}
                    />
                  )}

                  {props.data.faultAnalyzerSCProductsStats.count > 0 && (
                    <OrderItemRow
                      title={
                        CheckoutConstants.FALUT_ANALYZER_SERVICE_CENTER_PRODUCT_NAME
                      }
                      featurePrice={
                        props.data.faultAnalyzerSCProductsStats.price
                      }
                      isCouponApply={isCouponApply}
                      checkInsideReviewOrderData={checkInsideReviewOrderData}
                      discountAmountData={discountAmountData}
                    />
                  )}

                  {props.data.remoteTerminalSCProductsStats.count > 0 && (
                    <OrderItemRow
                      title={
                        CheckoutConstants.REMOTE_TERMINAL_BASIC_SERVICE_PRODUCT_NAME
                      }
                      featurePrice={
                        props.data.remoteTerminalSCProductsStats.price
                      }
                      isCouponApply={isCouponApply}
                      checkInsideReviewOrderData={checkInsideReviewOrderData}
                      discountAmountData={discountAmountData}
                    />
                  )}
                </Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>

          {/* Discount */}

          {isCouponApply ? (
            !checkInsideReviewOrderData ? (
              <Table.Row>
                <Table.Cell width={7}>
                  <Icon
                    root="common"
                    name="badge-delete"
                    size="small"
                    style={{
                      paddingRight: "3px",
                    }}
                  />
                  Discount
                  <p>
                    <img
                      src={DiscountIcon}
                      className="order-discount-icon"
                      alt="Discount Icon"
                    />

                    <span className="details-coupon-code" style={{}}>
                      {checkCouponData?.data?.promoCode}
                    </span>
                  </p>
                </Table.Cell>
                <Table.Cell width={7}>
                  <p style={{ color: "#28a745" }}>
                    - $ {discountAmount.data.toFixed(2)}
                  </p>
                </Table.Cell>
              </Table.Row>
            ) : (
              ""
            )
          ) : checkInsideReviewOrderData ? (
            ""
          ) : (
            ""
          )}

          <Table.Row className="order-summary-subtotal">
            <Table.Cell width={9}>
              <b>Subtotal</b>
            </Table.Cell>
            <Table.Cell width={7} className="sub-total-amount">
              ${" "}
              {getSubTotalPrice(
                props,
                getTotalDiscountAmount(discountAmountData)
              )}
            </Table.Cell>
          </Table.Row>
          <Table.Row className="order-summary-subtotal">
            <Table.Cell width={9}>Tax</Table.Cell>
            <Table.Cell width={7} className="tax-amount">
              $ {taxPrice}
            </Table.Cell>
          </Table.Row>
          {taxPrice > 0 && (
            <Table.Row>
              <Table.Cell colSpan={2}>
                <span className="tp-tax-note-text">
                  If you are tax exempt, please email us the tax certificate to
                </span>
                <a
                  className="co-link-text tp-tax-note-link"
                  href="mailto:dsa@honeywellaerospace.com"
                >
                  {" "}
                  dsa@honeywellaerospace.com.
                </a>
              </Table.Cell>
            </Table.Row>
          )}
          <Table.Row className="order-summary-subtotal">
            <Table.Cell width={9}>
              <b>Grand Total</b>
            </Table.Cell>
            <Table.Cell width={7} className="grand-total-amount">
              ${" "}
              {getGrandTotalPrice(
                props,
                getTotalDiscountAmount(discountAmountData)
              )}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  } else {
    return <h2>Something went wrong...</h2>;
  }
}

export class OrderSummery extends React.PureComponent<
  OrderSummeryPropsI & RouteComponentProps & OrderSummaryStatsPropsI
> {
  constructor(
    props: OrderSummeryPropsI & RouteComponentProps & OrderSummaryStatsPropsI
  ) {
    super(props);
  }

  componentDidMount() {
    this.props.getOrderSummary(this.props.userId);
    this.props.insideReviewOrder(false);
  }

  /** The consumer of this component need to place this in a grid layout **/
  render() {
    return (
      <Card>
        <Card.Header title="Order Summary" className="order-summary-title" />
        <Card.Content>
          {this.props.isFetching && (
            <InLineLoader
              loading={true}
              text="Fetching Order Summary"
              overlayColor="transparent"
            />
          )}
          {!this.props.isFetching && this.props.isSuccess && (
            <React.Fragment>
              <OrderSummaryDetails {...this.props} />
              {this.props.children}
            </React.Fragment>
          )}

          {!this.props.isFetching && !this.props.isSuccess && (
            <p>Something went wrong. Please try again.</p>
          )}
        </Card.Content>
      </Card>
    );
  }
}

const mapDispatchToProps = {
  getOrderSummary: OrderSummaryActions.getOrderSummary,
  insideReviewOrder: ReviewOrderActions.insideReviewOrder,
};

function mapStateToProps(state) {
  const { data, isFetching, isSuccess } = state.orderSummary.orderSummary;
  // Apply Coupon
  const checkCouponData1 = state.couponApiSummary?.couponApiSummary;
  const checkCouponData = checkCouponData1?.data;
  const couponData1 = state.couponSummary?.couponSummary;
  const couponData = couponData1?.couponData;
  const discountAmount1 = state.cartListData?.cartListData;
  const discountAmount = discountAmount1?.discountAmount;
  const checkInsideReviewOrder1 = state.reviewOrderData?.reviewOrderData;
  const checkInsideReviewOrder =
    checkInsideReviewOrder1?.checkInsideReviewOrder;
  const checkModeldata = state?.cartListModelData?.cartListModelData;
  const checkModelBdata = state?.cartListModelBData?.cartListModelBData;

  const userId = state.userValidationData.payload.userInfo.customer_sub;

  if (!isFetching && isSuccess) {
    return {
      data,
      userId,
      isFetching,
      isSuccess,
      couponData,
      discountAmount,
      checkInsideReviewOrder,
      checkCouponData,
      checkModeldata,
      checkModelBdata,
    };
  }
  return {
    data: void 0,
    isFetching,
    isSuccess,
    userId,
    couponData,
    discountAmount,
    checkInsideReviewOrder,
    checkCouponData,
    checkModeldata,
    checkModelBdata,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(OrderSummery));
